import { render, staticRenderFns } from "./cps-payment.vue?vue&type=template&id=7f9037cf&"
import script from "./cps-payment.vue?vue&type=script&lang=js&"
export * from "./cps-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports